import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Illustration, Redirect, Text } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { AuthLayoutContent } from '../AuthLayout/AuthLayoutContent';
import { AuthLayoutTitleGroup } from '../AuthLayout/AuthLayoutTitleGroup';
import { ResendVerificationEmail } from '../ResendVerificationEmail/ResendVerificationEmail';
import { useRegistrationContext } from './Registration.context';
import { RegistrationAccountantForm } from './RegistrationAccountantForm';
import { containerStyle, contentWrapperStyle, illustrationStyle, textMediumStyle, textStyle } from './RegistrationSuccess.css';

export const RegistrationSuccess = () => {
  const { clearRegistrationInformation, user } = useRegistrationContext();

  const { t } = useTranslation(['auth']);

  useEffect(() => {
    if (user) clearRegistrationInformation();
  }, [user, clearRegistrationInformation]);

  if (user === null) return <Redirect to={routes.login} />;

  return (
    <AuthLayoutContent>
      <Illustration className={illustrationStyle} name="HandsHeart" strokeWidth={0.9} />

      <div className={containerStyle}>
        <AuthLayoutTitleGroup
          eyebrow={t('auth:registrationPage.common.header.pill')}
          subtitle={
            user.eligible
              ? t('auth:registrationPage.stepSuccess.header.subtitle.eligible')
              : t('auth:registrationPage.stepSuccess.header.subtitle.ineligible')
          }
          title={t('auth:registrationPage.stepSuccess.header.title')}
        />

        {user.eligible ? (
          <div className={contentWrapperStyle}>
            <Text className={textStyle}>
              <Trans
                components={{ bold: <span className={textMediumStyle} /> }}
                i18nKey="auth:registrationPage.stepSuccess.message.eligible"
                values={{ email: user.email }}
              />
            </Text>

            <ResendVerificationEmail emailAddress={user.email} />
          </div>
        ) : (
          <Text>
            <Trans components={{ break: <br /> }} i18nKey="auth:registrationPage.stepSuccess.message.ineligible" />
          </Text>
        )}
      </div>

      <RegistrationAccountantForm userEmailAddress={user.email} />
    </AuthLayoutContent>
  );
};
